import { target } from '../config/awsExports';

export const ENV_TARGETS = {
  DEV: 'DEV',
  STAG: 'STAG',
  PRO: 'PRO',
};

export const isProdEnvironment = () => target === ENV_TARGETS.PRO;

export const isDevOrStagEnvironment = () => target === ENV_TARGETS.DEV || target === ENV_TARGETS.STAG;

export const shouldShowIpWhitelist = () => isProdEnvironment();
